/**
 * `reserved` (pre-auth funds hold) stays non-final on the backend until
 * capture or cancel, but for the customer the payment has already succeeded,
 * so the widget shows it as `completed`.
 */
const DISPLAY_STATUS_MAP = {
  reserved: { status: 'completed', isStatusFinal: true },
};

export const mapTransactionStatus = (data) => {
  const displayStatus = DISPLAY_STATUS_MAP[data?.status];

  return displayStatus ? { ...data, ...displayStatus } : data;
};
